var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "#0578be",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.194921 4.74447C0.0651985 4.6153 0 4.46078 0 4.28079C0 4.10401 0.0651985 3.95121 0.194921 3.82216L0.580155 3.44004C0.703295 3.31075 0.857385 3.24641 1.04243 3.24641C1.22714 3.24641 1.38123 3.31075 1.50437 3.44004L3.01402 4.93294L3.01402 1.34581C3.01402 1.16902 3.07822 1.02558 3.20663 0.915106C3.33504 0.804754 3.49012 0.749512 3.67154 0.749512L4.32841 0.749512C4.50982 0.749512 4.66491 0.804754 4.79331 0.915106C4.9214 1.02558 4.9856 1.16902 4.9856 1.34581L4.9856 4.93294L6.48997 3.44004C6.62036 3.31075 6.77609 3.24641 6.95751 3.24641C7.13894 3.24641 7.29467 3.31075 7.42473 3.44004L7.80996 3.82216C7.93639 3.95454 7.99994 4.10757 7.99994 4.28079C7.99994 4.45721 7.93639 4.61185 7.80996 4.74447L4.46702 8.06157C4.34059 8.18718 4.18484 8.25004 3.9998 8.25004C3.8118 8.25004 3.65771 8.18718 3.53786 8.06157L0.194921 4.74447Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.f098662c.svg";
export { ForwardRef as ReactComponent };